import SectionCard from '@/shared/components/SectionCard';
import { AccountList, useAccountsContext } from '@accounts';
import { useAuth } from '@auth';
import { PreparationDialog, useGuidedPreparationDialog } from '@preparation';
import { StatsPanel } from '@stats';

export default function DashboardSections() {
  const { user, plan, visaPreparation } = useAuth();
  const { accounts, isLoading } = useAccountsContext();

  const guides = plan?.guided_preparation ?? false;
  const isNewcomer = !isLoading && accounts.length === 0 && visaPreparation?.stage == null;
  const dialog = useGuidedPreparationDialog({ guides, isNewcomer, userId: user?.id ?? null });

  return (
    <div className="space-y-12">
      <SectionCard>
        <AccountList onNeedHelp={guides ? dialog.open : undefined} />
      </SectionCard>
      <SectionCard>
        <StatsPanel />
      </SectionCard>
      {guides && (
        <PreparationDialog isOpen={dialog.isOpen} source={dialog.source} onClose={dialog.close} />
      )}
    </div>
  );
}
